<template>
    <div class="step__item">
        <div class="step-time">
            <div class="step-time__date">{{date[0]}}</div>
            <div class="step-time__time">{{date[1]}}</div>
        </div>
        <div class="step-title">
            <div class="step-title__line" :class="'step-title__line' + iconClass"></div>
            <div class="step-title__icon" :class="'step-title__icon' + iconClass"></div>
            <slot></slot>
            <div v-if="this.value.classes" class="classes">班次号：{{ value.classes }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Step",
        props: {
            value: Object
        },
        computed: {
            iconClass() {
                switch (this.value.status) {
                    case 4:
                    case 7:
                        return '--circle' // 物流
                    case 8:
                        return '--person'
                    default:
                        return '--circle'
                }
            },
            date() {
                let date = this.value.date.split(' ')
                let time = date[1].split(':')[0] + ':' +  date[1].split(':')[1]
                date = date[0].split('-')[1] + '-' + date[0].split('-')[2]
                return [date, time]
            }
        }
    }
</script>

<style scoped lang="scss">
    .step__item {
        padding: 0 0.4rem;
        display: flex;
        flex-direction: row;
        overflow: hidden;
    }

    .step-time {
        color: #3A3A3A;
        text-align: right;
        width: 1.2rem;

        &__date {
            font-size: 0.35rem;
        }

        &__time {
            font-size: 0.29rem;
        }
    }

    .step-title {
        position: relative;
        font-size: 0.35rem;
        padding: 0 0 0.6rem 0.84rem;
        max-width: 70%;

        &__icon {
            position: absolute;
            top: 0;
            left: 0.42rem;
            transform: translateX(-50%);
            &--circle{
                width: 0.13rem;
                height: 0.13rem;
                background: #BCBCBC;
                border-radius: 50%;
            }
            &--person {
                width: 0.48rem;
                height: 0.48rem;
                background: url('../assets/icon-person.png') center / 100% no-repeat;
            }
            &--logistics {
                width: 0.48rem;
                height: 0.48rem;
                background: url('../assets/icon-logistics.png') center / 100% no-repeat;
            }
        }

        &__line {
            position: absolute;
            left: 0.42rem;
            transform: translateX(-50%);
            height: 100%;
            border-left: 1px solid #e4e4e4;
            &--circle {
                top: 0.13rem;
            }
            &--person {
                top: 0.48rem;
            }
            &--logistics {
                top: 0.48rem;
            }
        }
        .classes {
            color: #FE9329;
            font-size: 0.35rem;
        }
    }
</style>
